import { lazy } from "react"
import { RouteProps } from "../features.types"

const RenewVehiclePapersHome = lazy(
  () => import("./vehicle-paper-renewals/renewal-locations")
)
const RenewalPapers = lazy(
  () => import("./vehicle-paper-renewals/renewal-papers")
)
const RenewVehiclePapersController = lazy(
  () => import("./vehicle-paper-renewals/renew-vehicle-papers-controller")
)

const RegisterVehicleController = lazy(
  () => import("../process-papers/register-vehicle/register-vehicle-controller")
)
const RegisterVehicleHome = lazy(
  () => import("../process-papers/register-vehicle/register-locations")
)
const VehicleDetails = lazy(() => import("./register-vehicle/vehicle-details"))
const PersonalDetails = lazy(
  () => import("./register-vehicle/personal-details")
)
const RegistrationPreferences = lazy(
  () => import("./register-vehicle/registration-preferences")
)
const RegistrationPapers = lazy(
  () => import("./register-vehicle/registration-papers")
)

const ChangeOwnershipController = lazy(
  () => import("./change-ownership/change-ownership-controller")
)
const ChangeOwnershipHome = lazy(
  () => import("./change-ownership/change-ownership-locations")
)
const ChangeOwnershipVehicleDetails = lazy(
  () => import("./change-ownership/vehicle-details")
)
const ChangeOwnershipPersonalDetails = lazy(
  () => import("./change-ownership/personal-details")
)
const ChangeOwnershipPreferences = lazy(
  () => import("./change-ownership/ownership-preferences")
)
const ChangeOwnershipPapers = lazy(
  () => import("./change-ownership/change-ownership-papers")
)

const DriversLicenseRenewalController = lazy(
  () => import("./drivers-license-renewal/drivers-license-renewal-controller")
)
const DriversLicenseRenewalHome = lazy(
  () => import("./drivers-license-renewal/drivers-license-renewal")
)

const ComprehensiveInsuranceController = lazy(
  () => import("./comprehensive-insurance/comprehensive-insurance-controller")
)
const ComprehensiveInsuranceHome = lazy(
  () => import("./comprehensive-insurance/comprehensive-insurance")
)
const AddComprehensiveInsurance = lazy(
  () => import("./comprehensive-insurance/insurance-details")
)
const ComprehensiveInsuranceUpload = lazy(
  () => import("./comprehensive-insurance/upload-details")
)

const VehicleTrackingController = lazy(
  () => import("./vehicle-tracking/vehicle-tracking-controller")
)
const VehicleTrackingHome = lazy(
  () => import("./vehicle-tracking/vehicle-tracking")
)
const VehicleTrackingDetails = lazy(
  () => import("./vehicle-tracking/tracking-details")
)

// define route constant
export const RENEW_PAPERS_ROUTE = "process-papers/renewals"
export const RENEWAL_PAPERS = "process-papers/renewals/vehicle-papers"
//
export const REGISTER_VEHICLE_ROUTE = "process-papers/register"
export const VEHICLE_DETAILS = "process-papers/register/vehicle"
export const PERSONAL_DETAILS = "process-papers/register/personal-details"
export const REGISTRATION_PREFERENCES =
  "process-papers/register/registration-preferences"
export const REGISTRATION_PAPERS = "process-papers/register/registration-papers"
//
export const CHANGE_OWNERSHIP_ROUTE = "process-papers/ownership"
export const CHANGE_OWNERSHIP_VEHICLE_DETAILS =
  "process-papers/ownership/vehicle-details"
export const CHANGE_OWNERSHIP_PERSONAL_DETAILS =
  "process-papers/ownership/personal-details"
export const CHANGE_OWNERSHIP_PREFERENCES =
  "process-papers/ownership/registration-preferences"
export const CHANGE_OWNERSHIP_PAPERS =
  "process-papers/ownership/ownership-papers"
//
export const DRIVERS_LICENSE_RENEWAL_ROUTE = "process-papers/drivers-license"

//
export const COMPREHENSIVE_INSURANCE_ROUTE =
  "process-papers/comprehensive-insurance"
export const INSURANCE_DETAILS_ROUTE =
  "process-papers/comprehensive-insurance/insurance-details"
export const COMPREHENSIVE_INSURANCE_UPLOAD_ROUTE =
  "process-papers/comprehensive-insurance/uploads"

//
export const VEHICLE_TRACKING_ROUTE = "process-papers/vehicle-tracking"
export const VEHICLE_TRACKING_DETAILS_ROUTE =
  "process-papers/vehicle-tracking/details"

//define routes
export const ProcessPapers: RouteProps[] = [
  {
    path: RENEW_PAPERS_ROUTE,
    Component: RenewVehiclePapersController,
    children: [
      {
        index: true,
        Component: RenewVehiclePapersHome,
      },
      {
        path: `/${RENEWAL_PAPERS}`,
        Component: RenewalPapers,
      },
    ],
  },
  {
    path: REGISTER_VEHICLE_ROUTE,
    Component: RegisterVehicleController,
    children: [
      {
        index: true,
        Component: RegisterVehicleHome,
      },
      {
        path: `/${VEHICLE_DETAILS}`,
        Component: VehicleDetails,
      },
      {
        path: `/${PERSONAL_DETAILS}`,
        Component: PersonalDetails,
      },
      {
        path: `/${REGISTRATION_PREFERENCES}`,
        Component: RegistrationPreferences,
      },
      {
        path: `/${REGISTRATION_PAPERS}`,
        Component: RegistrationPapers,
      },
    ],
  },
  {
    path: CHANGE_OWNERSHIP_ROUTE,
    Component: ChangeOwnershipController,
    children: [
      {
        index: true,
        Component: ChangeOwnershipHome,
      },
      {
        path: `/${CHANGE_OWNERSHIP_VEHICLE_DETAILS}`,
        Component: ChangeOwnershipVehicleDetails,
      },
      {
        path: `/${CHANGE_OWNERSHIP_PERSONAL_DETAILS}`,
        Component: ChangeOwnershipPersonalDetails,
      },
      {
        path: `/${CHANGE_OWNERSHIP_PREFERENCES}`,
        Component: ChangeOwnershipPreferences,
      },
      {
        path: `/${CHANGE_OWNERSHIP_PAPERS}`,
        Component: ChangeOwnershipPapers,
      },
    ],
  },
  {
    path: DRIVERS_LICENSE_RENEWAL_ROUTE,
    Component: DriversLicenseRenewalController,
    children: [
      {
        index: true,
        Component: DriversLicenseRenewalHome,
      },
    ],
  },
  {
    path: COMPREHENSIVE_INSURANCE_ROUTE,
    Component: ComprehensiveInsuranceController,
    children: [
      {
        index: true,
        Component: ComprehensiveInsuranceHome,
      },
      {
        path: `/${INSURANCE_DETAILS_ROUTE}`,
        Component: AddComprehensiveInsurance,
      },
      {
        path: `/${COMPREHENSIVE_INSURANCE_UPLOAD_ROUTE}`,
        Component: ComprehensiveInsuranceUpload,
      },
    ],
  },
  {
    path: VEHICLE_TRACKING_ROUTE,
    Component: VehicleTrackingController,
    children: [
      {
        index: true,
        Component: VehicleTrackingHome,
      },
      {
        path: `/${VEHICLE_TRACKING_DETAILS_ROUTE}`,
        Component: VehicleTrackingDetails,
      },
    ],
  },
]
